<template>
		<Header/>
		<div v-if="initError" class="init-error">
			<div class="init-error__content" v-html="initError"></div>
		</div>
		<main v-else class="main-app container" :class="{
				'logged': userLoggedIn,
				'home': router.currentRoute.value.name === 'home',
				'info-status': router.currentRoute.value.name === 'info-status',
				'main-page': router.currentRoute.value.name === 'main-page',
				'success-pay': router.currentRoute.value.name === 'success-pay',
				'cancel-pay': router.currentRoute.value.name === 'cancel-pay',
				'pending-pay': router.currentRoute.value.name === 'pending-pay',
				'payment-history': router.currentRoute.value.name === 'payment-history',
			}">
			<Navbar v-if="!isTablet && userLoggedIn" class="main-app__sidebar"/>
			<div class="main-app__content" :class="{
					'payment-history': router.currentRoute.value.name === 'payment-history',
					'contract-info': router.currentRoute.value.name === 'contract-info',
					'payment': router.currentRoute.value.name === 'payment',
					'contract-docs': router.currentRoute.value.name === 'contract-docs',
					'archieve': router.currentRoute.value.name === 'archieve'
				}">
				<router-view></router-view>
			</div>
		</main>
	<GlobalPreloader v-if="store.state.globalPreloader"/>
</template>
<script setup>
import Header from '@/widgets/Header';
import useScreenResolutionResizeMobile from '@/shared/lib/hooks/useScreenResolutionResizeMobile';
import useScreenResolutionResizeTablet from '@/shared/lib/hooks/useScreenResolutionResizeTablet';
import { computed, watchEffect } from 'vue';
import GlobalPreloader from '@/shared/components/Preloaders/GlobalPreloader/GlobalPreloader.vue';
import { useStore } from 'vuex';
import initCentrifuge from '@/processes/Centrifuge/initCentrifuge';
import Navbar from '@/entities/components/Navbar/Navbar.vue';
import { useRouter } from 'vue-router';

useScreenResolutionResizeMobile();
useScreenResolutionResizeTablet();
const store = useStore();
const router = useRouter();
const isTablet = computed(() => store.state.isTablet.isTablet);
const userLoggedIn = computed(() => store.state.user);
const initError = computed(() => store.state.initError?.replace(/\n/g, '<br>'));

console.log(process.env);
watchEffect(() => {
	if (store.state.centrifugeToken && store.state.loan?.uid) {
		initCentrifuge();
	}
});

function setSumPeriodStorage() {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());

	if (params.sum && params.days) {
		localStorage.setItem('calculator', JSON.stringify(params));
	}
}
setSumPeriodStorage();

async function sendPushUtmUid() {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());

	if (!params.sub_to_mailing) return;

	try {
		const response = await store.dispatch('webPush/confirmPushOpening', params.sub_to_mailing);
		console.log('sendPushUtmUid Response:', response);
	} catch (err) {
		console.log('sendPushUtmUid Error:', err);
	}
}
sendPushUtmUid();

</script>
